// URLS
const DB_URL = "https://www.openligadb.de/api";
const API_URL = process.env.VUE_APP_URL;

// SETTINGS
const DEV_MODE = process.env.VUE_APP_TEST;

module.exports = { DB_URL, API_URL, DEV_MODE };
